// LiveAgent domain-internal constants. Everything here is consumed only inside
// src/liveAgent — the analytics discriminators the module emits and the idle TTL its
// escalation lifecycle enforces.
//
// The `LIVE_AGENT_*_MESSAGE` system-message payloads deliberately stay in
// `shared/constants.js`: they are Conversation system-message *content*, written by
// flows/askUserQuestion, flows/botResponse and shared/utils/message-utils as well as by
// this module. Moving them here would make `shared/` import a domain — a layering
// inversion. Ownership follows the consumer set, not the name prefix.

// --- Analytics discriminators (the `lvQuestion` field of the submit-click payload).
// These are live analytics contracts — the strings are consumed downstream. Do not edit.
export const LIVE_AGENT_ANALYTICS_CONNECTION_STRING = 'lv:connect:session start';
export const LIVE_AGENT_ANALYTICS_DISCONNECTION_STRING = 'lv:disconnect:session end';
export const LIVE_AGENT_ANALYTICS_CUSTOM_MESSAGE_PREFIX = 'lv:custom:';
export const LIVE_AGENT_ANALYTICS_FIRST_MESSAGE_SUFFIX = ':is first message';
export const LIVE_AGENT_ANALYTICS_SURVEY_RECEIVED = 'lv:survey receive';
export const LIVE_AGENT_ANALYTICS_SURVEY_STARTED = 'lv:survey start';

// --- Escalation idle timeout. The engine prefers the `sprinklr-idle-timeout` Experience
// Config value when one is provided and falls back to this.
export const IDLE_TTL_MS = 6 * 60 * 60 * 1000; // 6 hours
